<template>
  <v-card
    rounded
    outlined
    style="height: 76px"
    class="d-flex justify-space-between px-2 py-2 card-active"
    :class="active ? `card-active__${entityType}` : 'card-hover'"
    @click="$emit('click')"
  >
    <div class="d-flex flex-column justify-center">
      <p class="ma-0 pa-0 h6 blue-grey--text text--darken-3">
        {{ count }}
      </p>
      <p class="ma-0 pa-0 caption blue-grey--text text--darken-1">
        {{ entityName }}
      </p>
    </div>
    <div class="d-flex flex-column justify-start align-start">
      <EntityIcon circle :entityType="entityType" :active="active" />
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

import EntityIcon from '@/components/EntityIcon.vue'
import _ from 'lodash'

export default {
  name: 'EntityCountCard',
  props: { active: Boolean, count: Number, entityType: String },
  components: {
    EntityIcon,
  },

  computed: {
    ...mapGetters(['organization']),

    entityName() {
      const pluralization = this.count === 1 ? 'singular' : 'plural'

      const customName =
        this.organization?.customNamings?.[this.entityType]?.[pluralization] ??
        null

      return (
        customName ||
        this.$t(`common.${_.snakeCase(this.entityType)}`, {
          count: this.count,
        })
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.card-active {
  &__rev {
    border: 1px solid $color-blue !important;
    background: $color-blue-lighten2 !important;
    .v-card--link:focus {
      background: $color-blue-lighten2 !important;
    }
  }
  &__improvementIdea {
    border: 1px solid $color-blue !important;
    background: $color-blue-lighten2 !important;
    .v-card--link:focus {
      background: $color-blue-lighten2 !important;
    }
  }
  &__quickAction {
    border: 1px solid $color-orange !important;
    background: $color-orange-lighten2;
  }
  &__problemSolving {
    border: 1px solid $color-red !important;
    background: $color-red-lighten2;
  }
  &__task {
    border: 1px solid $color-green !important;
    background: $color-green-lighten2;
  }
  &__routine {
    border: 1px solid $color-teal !important;
    background: $color-teal-lighten2;
  }
  &__finding {
    border: 1px solid $color-blue-grey !important;
    background: $color-blue-grey-lighten2;
  }
}
.v-card--link:focus::before {
  opacity: 0;
}
</style>
